import React, { useEffect, useState } from "react";
import axios from "axios";
import { AlertTriangle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Public hurricane-watch banner. Shows on landing + dashboard when admin enables it. */
export default function HurricaneBanner({ compact = false }) {
  const [s, setS] = useState(null);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/site-settings/public`).then((r) => alive && setS(r.data)).catch(() => {});
    return () => { alive = false; };
  }, []);

  if (!s?.hurricane_mode_enabled) return null;
  const msg = s.hurricane_message || "Storm watch in effect.";

  return (
    <div
      data-testid="hurricane-banner"
      className={`relative z-30 bg-amber-500 text-amber-950 ${compact ? "py-2" : "py-3"}`}
    >
      <div className="max-w-6xl mx-auto px-6 flex items-center gap-3">
        <AlertTriangle className="w-5 h-5 shrink-0 animate-pulse" />
        <div className="text-sm font-medium">{msg}</div>
      </div>
    </div>
  );
}
